var React = require('react');

function EMail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"email_24px"},React.createElement("path",{"id":"icon/communication/email_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M4 4H20C21.1 4 22 4.89999 22 6V18C22 19.1 21.1 20 20 20H4C2.90002 20 2 19.1 2 18L2.01001 6C2.01001 4.89999 2.90002 4 4 4ZM12.53 12.67L19.6 8.25C19.85 8.09 20 7.82001 20 7.53C20 6.86002 19.27 6.46002 18.7 6.81L12 11L5.29999 6.81C4.72998 6.46002 4 6.86002 4 7.53C4 7.82001 4.15002 8.09 4.40002 8.25L11.47 12.67C11.79 12.87 12.21 12.87 12.53 12.67Z","fill":"black","fillOpacity":"0.54"})));
}

EMail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EMail;

EMail.default = EMail;
